export const autocomplete = {
  autocomplete: {
    colorScheme: {
      light: {
        dropdown: {
          background: '{primary.500}',
          borderColor: '{primary.500}',
          hoverBorderColor: '{primary.400}',
          hoverBackground: '{primary.400}',
          color: 'var(--p-surface-0)',
          hoverColor: 'var(--p-surface-0)',
          activeBorderColor: '{primary.400}',
          activeBackground: '{primary.400}',
          activeColor: 'var(--p-surface-0)',
        },
        chip: {
          borderRadius: 'var(--p-border-radius-xl)',
        },
      },
    },
  },
};
